import {
  ThemeProvider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FilledInput,
} from '@mui/material';
import React from 'react';
import { assetSelectTheme } from '@/app/styles/muiTheme';
import type { SelectChangeEvent } from '@mui/material';

export interface Asset {
  entityDisplayName: string;
}

export interface AssetSelectProps {
  selectValue: string;
  handleChange: (_event: SelectChangeEvent) => void;
  assets: Asset[] | null | undefined;
  title: string;
  filledInputName: string;
  htmlFor: string;
}

export const AssetSelect: React.FC<AssetSelectProps> = ({
  selectValue,
  handleChange,
  assets,
  title,
  filledInputName,
  htmlFor,
}) => {
  let internalSelectValue = selectValue;

  if (assets && assets.length === 1) {
    internalSelectValue = assets[0].entityDisplayName;
  }

  return (
    <ThemeProvider theme={assetSelectTheme}>
      <FormControl
        variant='filled'
        sx={{
          mb: '1.3rem',
          width: '76%',
          '@media (max-device-width:780px)': {
            width: '72%',
          },
        }}
      >
        <InputLabel
          htmlFor={htmlFor}
          sx={{
            fontSize: '1.4rem',
            color: '#7b1b17',
            '@media (max-width:599px)': {
              fontSize: '0.7rem',
              pt: '20px',
            },

            '@media (min-width:600px) and (max-width:780px)': {
              fontSize: '1rem',
              pt: 2,
            },
            }}
          >
          {title}
        </InputLabel>

        <Select
          value={internalSelectValue}
          onChange={handleChange}
          input={<FilledInput name={filledInputName} id={htmlFor} />}
          sx={{
            fontSize: 15,
            '@media (max-width:599px)': {
              height: 80,
              fontSize: '0.6rem',
              pt: 4,
            },

            '@media (min-width:600px) and (max-width:780px)': {
              height: 80,
              fontSize: '0.8rem',
              pt: 4,
            },
          }}
        >
          {assets?.map((asset) => (
            <MenuItem
              key={asset.entityDisplayName}
              value={asset.entityDisplayName}
              sx={{
                fontSize: '1rem',
                '@media (max-width:599px)': {
                  fontSize: '0.5rem',
                },

                '@media (min-width:600px) and (max-width:780px)': {
                  fontSize: '1rem',
                },
              }}
            >
              {asset.entityDisplayName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </ThemeProvider>
  );
};

export default AssetSelect;
